import React, { FunctionComponent } from "react";
import { Drawer, Button, makeStyles} from "@material-ui/core";
import GradienBoderButton from "../commonComponents/GradientButton";
import akpLogoWhite from "../images/Logo/ApP-Logo-weiss.svg";
import closeIconWhite from "../images/Icons/close-weiss_icn.svg";
import Text from "../commonComponents/Text";
import PostalHint from "../commonComponents/PostalHint";
import SvgButton from "../commonComponents/SvgButton";
import {I18n} from "aws-amplify";

const useStyles = makeStyles((theme) => ({
    drawer: {
        display: "grid",
        justifyItems: "center",
        alignItems: "center",
        paddingBottom: 40,
        overflowX: "hidden"
    },
    headline: {
        display: "grid",
        gridTemplateColumns: "max-content max-content",
        justifyItems: "center",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        height: 60,
        background: "linear-gradient(to right, #71C8CD, #DB9649, #E25843)",
        marginBottom: theme.spacing(2)
    },
    drawerItem: {
        padding: theme.spacing(1),
        width: "100%",
        textAlign: "center"
    },
    logo: {
        marginLeft: 16
    },
    closeIcon: {
        marginRight: 16
    }
}));

interface DrawerProps {
    isOpen: boolean;
    toggle: () => void;
}
const TopDrawer: FunctionComponent<DrawerProps> = ({ isOpen, toggle }) => {
    const classes = useStyles();

    const onJetztVerkaufenClicked = () => toggle();

    return (
        <Drawer anchor="top" open={isOpen} onClose={toggle} transitionDuration={600}>
            <div className={classes.drawer}>
                <div className={classes.headline}>
                    <img src={akpLogoWhite} alt={"logo"} className={classes.logo}/>
                    <SvgButton svg={closeIconWhite} onClick={toggle} className={classes.closeIcon}/>
                </div>
                <div className={classes.drawerItem}>
                    <Button
                        fullWidth={true}
                        target="_blank"
                        href={"https://www.ankaufperpost.com/#ueber-uns"}
                    >
                        <Text value={I18n.get("topBar").whatIsIt} size={18}/>
                    </Button>
                </div>
                <div className={classes.drawerItem}>
                    <Button
                        fullWidth={true}
                        target="_blank"
                        href={"https://www.ankaufperpost.com/#wie-funktioniert"}
                    >
                        <Text value={I18n.get("topBar").howDoesItWork} size={18}/>
                    </Button>
                </div>
                <div className={classes.drawerItem}>
                    <Button
                        fullWidth={true}
                        target="_blank"
                        href={"https://www.ankaufperpost.com/#faq"}
                    >
                        <Text value={"FAQ"} size={18}/>
                    </Button>
                </div>
                <div className={classes.drawerItem}>
                    <GradienBoderButton text="Jetzt verkaufen" onClick={onJetztVerkaufenClicked} />
                </div>
                <PostalHint/>
            </div>
        </Drawer>
    );
};

export default TopDrawer;
